module.exports = __webpack_public_path__ + "static/shop_link.da0c3a18.jpg";